import {
  Bar,
  BarChart,
  Cell,
  CartesianGrid,
  LabelList,
  ReferenceLine,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { NRR_RATE } from "./exampleData";
import {
  BORDER,
  CHART_NEGATIVE,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Net Revenue Retention by month — bars colored by whether they clear the 100%
 * line: at or above 100% the existing book is growing (green), below it is
 * shrinking (red). The dashed line marks the starting-revenue break-even.
 */
const NrrChart = () => (
  <MetricChartFrame
    caption="NRR dips to 98% in a soft month, then expansion carries it above the 100% line to 105% — where the existing book grows on its own. Anything under the line means churn and contraction are winning."
    chartType="Line"
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={NRR_RATE} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => `${v}%`} domain={[0, 120]} width={44} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [`${value}%`, "Net revenue retention"]}
      />
      <Bar dataKey="value" radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => `${v}%`}
          fontSize={11}
          fill={MUTED_FG}
        />
        {NRR_RATE.map((row) => (
          <Cell key={row.label} fill={row.value >= 100 ? CHART_POSITIVE : CHART_NEGATIVE} />
        ))}
      </Bar>
      {/* Draw the 100% break-even line on top of the bars (they straddle it). */}
      <ReferenceLine y={100} stroke={MUTED_FG} strokeDasharray="4 4" />
    </BarChart>
  </MetricChartFrame>
);

export default NrrChart;
